import React, { useState, useEffect } from 'react';
import { ButtonBase, Skeleton, Typography } from '@mui/material';
import { getDoc } from 'firebase/firestore';
import { formatDateTime, renderValueCurrency } from '../../utils/utils';
import { Actions, useDispatchProvider } from '../utils/StateProvider';

const ViewOrder = ({ orderRef }) => {
  const [orderData, setOrderData] = useState(null);
  const dispatch = useDispatchProvider();
  // const supplierDocRef = doc(db, 'suppliers', supplierId);
  // const supplierDocRef = getDoc(supplierRef);
  // const [supplierData, loading] = useDocumentData(supplierRef ?? null);
  useEffect(() => {
    // console.log(orderRef);
    const fetchOrder = async () => {
      const orderSnap = await getDoc(orderRef);
      // console.log(orderSnap.data());
      if (orderSnap.exists()) {
        setOrderData({ id: orderSnap.id, ...orderSnap.data() });
      }
    };
    if (orderRef.id) {
      fetchOrder().then();
    }
  }, [orderRef]);
  const handleClickOrder = (e) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch && dispatch({ type: Actions.FormOrder, payload: orderData.id });
    dispatch && dispatch({ type: Actions.TabsOrder, payload: 'products' });
    dispatch && dispatch({ type: Actions.DrawerOrder, payload: true });
  };

  if (!orderData && orderRef.id)
    return (
      <>
        <Skeleton
          variant={'text'}
          height={24}
          animation={'wave'}
        />
        <Skeleton
          variant={'text'}
          height={20}
          animation={'wave'}
        />
      </>
    );
  if (orderData)
    return (
      <ButtonBase
        onTouchStart={(event) => event.stopPropagation()}
        onTouchCancel={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={handleClickOrder}
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          textAlign: 'left',
          '&:hover': { backgroundColor: 'primary.main' },
          p: 1,
          m: -1,
          borderRadius: 1,
        }}
      >
        <Typography component={'div'}>{formatDateTime(orderData.dateCreated)}</Typography>
        <Typography
          color={'textSecondary'}
          variant={'body2'}
          component={'div'}
        >
          {renderValueCurrency(orderData.total)}
        </Typography>
      </ButtonBase>
    );
};

export default ViewOrder;
